module.exports = __webpack_public_path__ + "images/emoji/rotating_light.ad782675a6d15afc8d83.png";